import React, { Component } from 'react'
import { connect } from 'react-redux'

import Layout from './components/BodyLayout'
import Row from './components/Row'

import BrokerPerformanceCard from 'broker/views/components/BrokerPerformanceCard'
import BrokerOpportunitiesCard from 'broker/views/components/BrokerOpportunitiesCard'
import BrokerActivityCard from 'broker/views/components/BrokerActivityCard'
import BrokerCoverageCard from 'broker/views/components/BrokerCoverageCard'
import BrokerTopPerformingAgentsCard from 'broker/views/components/BrokerTopPerformingAgentsCard'
import BrokerAgentStatsCard from 'broker/views/components/BrokerAgentStatsCard'

import { fetchAccount } from 'broker/redux/account'

class Dashboard extends Component {
  componentDidMount() {
    this.props.fetchAccount()
  }

  render() {
    return (
      <Layout>
        <Row>
          <BrokerPerformanceCard/>
        </Row>
        <Row>
          <BrokerOpportunitiesCard/>
        </Row>
        <Row>
          <BrokerActivityCard/>
          <BrokerCoverageCard/>
        </Row>
        <Row>
          <BrokerAgentStatsCard/>
        </Row>
        <Row>
          <BrokerTopPerformingAgentsCard/>
        </Row>
      </Layout>
    )
  }
}

const actions = { fetchAccount }

export default connect(null, actions)(Dashboard)
